import { useAuth } from '@shared/auth';
import { Skeleton } from '@shared/components';

import { useSideBar } from '../../../contexts';
import MenuItem, { type MenuItemProps } from '../MenuItem';

import UserAvatarIcon from './UserAvatarIcon';

type UserMenuItemProps = Partial<MenuItemProps>;

function UserMenuItem(props: Readonly<UserMenuItemProps>) {
  const { user } = useSideBar();
  const { profileLoading: isProfileLoading } = useAuth();

  return (
    <MenuItem
      {...props}
      label={
        isProfileLoading ? (
          <Skeleton variant='text' sx={{ width: '100%', height: '100%' }} />
        ) : (
          (user.displayName.trim() ?? 'Guest User')
        )
      }
      icon={<UserAvatarIcon />}
    />
  );
}

export default UserMenuItem;
